// extracted by mini-css-extract-plugin
export default {"title":"CardMany_title__Yg5mX","content":"CardMany_content__dTINV","contentText":"CardMany_contentText__Ldwgm"};